<!-- from to edit alloys-->
<!-- loader-->
<div *ngIf="loading">
  <div class="loading">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
<!-- end loader-->
<ng-container  *ngIf="!loading">
  <ng-container  *ngIf="role === 'CUSTOMER'">
    <div class="alert alert-primary" role="alert">
      Edit this Alloy Here
    </div>
    <form id="bg"  [formGroup]="alloyForm" (ngSubmit)="onSubmit()" >
      <div class="card-deck">
        <!-- column 1-->

              <div id="box1">
                <div class="card1">
                  <div class="card-body">

                    <div class="row">
                      <h5 id="left" class="card-title">CLASS :</h5>
                      <!-- <mat-radio-group formControlName="iron1" class="example-radio-group">
                        <mat-radio-button class="example-radio-button" value="Grey Iron"><h3 id="ironText">Grey Iron</h3></mat-radio-button>
                        <mat-radio-button class="example-radio-button" value="Ductile Iron"><h3 id="ironText">Ductile Iron</h3></mat-radio-button>
                      </mat-radio-group> -->
                      <mat-form-field appearance="fill" style="margin: 0 auto;">
                        <mat-select formControlName="iron1">
                          <mat-option *ngFor="let type of gIron" [value]="type">
                            {{ type }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- <div class="error-spacer">
                        <mat-error *ngIf="alloyForm.controls['iron1'].invalid && alloyForm.controls['iron1'].errors.required">'IRON' is required</mat-error>
                      </div> -->
                    </div>





                    <div class="row">

                      <h5 id="left" class="card-title">GRADE : </h5>
                      <input id="right" type="text" class="card3" formControlName="grade">
                    
                    </div>
                    <div class="error-spacer">
                      <mat-error *ngIf="alloyForm.controls['grade'].invalid && alloyForm.controls['grade'].errors.required">Grade is required</mat-error>
                    </div>


                    <div class="row">
                      <h5 id="left" class="card-title">DESCRIPTION :</h5>
                      <textarea id="right" type="text" class="card3" formControlName="name"></textarea>
                    </div>
                    <!-- <div class="error-spacer">
                    <mat-error *ngIf="alloyForm.controls['name'].invalid && alloyForm.controls['name'].errors.required">Name is required</mat-error>
                    </div> -->

                    <!-- <div class="row">
                      <h5 id="left" class="card-title">Heat ID</h5>
                      <input id="right" type="text" class="card3" formControlName="heatNumber">
                    </div>
                    <div class="error-spacer">
                    <mat-error *ngIf="alloyForm.controls['heatNumber'].invalid && alloyForm.controls['heatNumber'].errors.required">Heat ID is required</mat-error>
                    <mat-error *ngIf="alloyForm.controls['heatNumber'].invalid && alloyForm.controls['heatNumber'].errors.minlength">Minimum length is 8</mat-error>
                    <mat-error *ngIf="alloyForm.controls['heatNumber'].invalid && alloyForm.controls['heatNumber'].errors.maxlength">Maximum length is 15</mat-error>
                    </div> -->

               

                      <br><br>
                      <div class="row">

                        <h5 id="left" class="card-title">TYPE :</h5>
                        <!-- <mat-radio-group formControlName="iron2" class="example-radio-group">
                          <mat-radio-button class="example-radio-button" value="Base Iron"><h3 id="ironText">Base Iron</h3></mat-radio-button>
                          <mat-radio-button class="example-radio-button" value="Final Iron"><h3 id="ironText">final Iron</h3></mat-radio-button>
                        </mat-radio-group>
                        <div class="error-spacer">
                          <mat-error *ngIf="alloyForm.controls['iron2'].invalid && alloyForm.controls['iron2'].errors.required">'IRON' is required</mat-error>
                        </div> -->

                        <mat-form-field appearance="fill" style="margin: 0 auto;">
                          <mat-select formControlName="iron2">
                            <mat-option *ngFor="let type of ironType" [value]="type">
                              {{ type }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>

                      </div>

                        <br><br>
                      

                  </div>
                </div>

              </div>

        <!-- end of first column-->
        <!-- column 2-->

        <div class="card1 col-md-5" id= "col2">
        <div formGroupName="chemistry">

            <h5 class="card-heading1">CHEMISTRY</h5><br>
            <!-- Header line in chemistry-->
            <div class="row" id="row1">
              <div class="col-md-2">
                Element
              </div>
              <div class="col-md-3">
                MIN
              </div>
              <div class="col-md-3">
                MAX
              </div>
              <div class="col-md-3">
                MEAN
              </div>
            </div>
            <!-- header line end-->
        <div>
            <div class="row" id="row1" formGroupName="C">
                <div class="col-md-2">
                  <h3> C </h3>
                </div>
                <div class="col-md-3" formGroupName="minmax">
                  <input class="card3" step=0.001 type="number" min=0 formControlName="min">
                </div>
                <div class="col-md-3" formGroupName="minmax">
                  <input class="card3" step=0.001 type="number" max=100 formControlName="max">
                </div>
                <div class="col-md-3">
                  <input readonly class="card3" type="number" formControlName="mean" step=0.001>
                </div>
            </div>
            <div class="row" id="row1" formGroupName="Si">
              <div class="col-md-2">
                <h3> Si </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Mn">
              <div class="col-md-2">
                <h3> Mn </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="P">
              <div class="col-md-2">
                <h3> P </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="S">
              <div class="col-md-2">
                <h3> S </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Fe">
              <div class="col-md-2">
                <h3> Fe </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Cr">
              <div class="col-md-2">
                <h3> Cr </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Cu">
              <div class="col-md-2">
                <h3> Cu </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Mg">
              <div class="col-md-2">
                <h3> Mg </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Ni">
              <div class="col-md-2">
                <h3> Ni </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>
            <div class="row" id="row1" formGroupName="Mo">
              <div class="col-md-2">
                <h3> Mo </h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>


            <div class="row" id="row1" formGroupName="V">
              <div class="col-md-2">
                <h3>V</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="Sn">
              <div class="col-md-2">
                <h3>Sn</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="Nb">
              <div class="col-md-2">
                <h3>Nb</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="B">
              <div class="col-md-2">
                <h3>B</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="W">
              <div class="col-md-2">
                <h3>W</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="Zn">
              <div class="col-md-2">
                <h3>Zn</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="Pb">
              <div class="col-md-2">
                <h3>Pb</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="Ti">
              <div class="col-md-2">
                <h3>Ti</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>

            <div class="row" id="row1" formGroupName="Sr">
              <div class="col-md-2">
                <h3>Sr</h3>
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" min=0 formControlName="min">
              </div>
              <div class="col-md-3" formGroupName="minmax">
                <input class="card3" step=0.001 type="number" max=100 formControlName="max">
              </div>
              <div class="col-md-3">
                <input readonly class="card3" type="number" formControlName="mean" step=0.001>
              </div>
            </div>




        </div><!-- end of form container-->


        </div><!-- ending chemistry form-->
      </div><!-- ending the secong column-->

         <!-- column 3-->

        <div id="col3" class="col-md-2">
          <div class="card2" formGroupName="calculatedValues">
           <!-- <h4 class="card-heading1">FINAL</h4> 
            <div>
              <div class="row">
                <div class="card-5">
                    <div class="card-heading2" > GRADE SELECTED: </div>
                    <input id="in" readonly type="text" formControlName="GRADE" >
                </div>
              </div>
            </div> -->
            <br>
            <div>
              <div class="row">
                <div class="card-5">
                  <div class="card-heading2">GEL: </div>
                  <input id="in" readonly type="text" formControlName="GEL">
                </div>
              </div>
            </div>
            <br>
            <div>
              <div class="row">
                <div class="card-5">
                  <div class="card-heading2">WEL: </div>
                  <input id="in" readonly type="text" formControlName="WEL">
                </div>
              </div>
            </div>
            <br>
            <div>
              <div class="row">
                <div class="card-5">
                  <div class="card-heading2">TL Reference: </div>
                  <input id ="in" readonly type="text" formControlName="TL_REF">
                </div>
              </div>
            </div>
            <br>
          </div>
          <br><br>
          <!-- Edit GEL WEL section-->
          <button type="button" (click)="switchEdit($event)">Click to Edit GEl / WEL Values<br> Else Proceed to Submit</button>
          <br>
          <div *ngIf="editGELWEL" id="col4" class="col-md-3">
            <div class="card2 " formGroupName="calculatedValues">
              <h4 class="card-heading1">Edit GEL/WEL</h4>
              <div>
                <div class="row">
                  <div class="card-5">
                    <div class="card-heading2">GEL: </div>
                    <input id="in" type="text" formControlName="GEL">
                  </div>
                </div>
              </div>
              <br>
              <div>
                <div class="row">
                  <div class="card-5">
                    <div class="card-heading2">WEL: </div>
                    <input id ="in" type="text" formControlName="WEL">
                  </div>
                </div>
              </div>
              <br>
            </div>
            <br>

          </div><!-- end edit gel/wel-->
          <div>
            <div id="buttons" class="row">
              <div id="left1">
                <button class="submit" type="submit" [disabled]="!alloyForm.valid" style="background-color: rgb(111, 192, 30);">Submit</button>
              </div>
              <div id="right1">
                <button class="submit" style="background-color: rgb(173, 56, 56);" (click)="resetForm()">Reset</button>
              </div>
              <!-- <div id="center">
                <button class="submit" style="background-color: grey;" >HELP</button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>

